(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5883],{

/***/ 55883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9970);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26538);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56399);
/* harmony import */ var _books_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63532);
/* harmony import */ var _books_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_books_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32033);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39181);
/* harmony import */ var _data_products__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7069);









var Books = function(param) {
    var products = param.products;
    var product = products[0];
    var handleLearnMore = function() {
        var slug = (0,_data_products__WEBPACK_IMPORTED_MODULE_5__/* .getProductSlugById */ .Ji)(product._id) || product.product_name.toLowerCase();
        window.open("/video-plugin-framework/".concat(slug), "_blank");
    };
    var handleFreeTrial = function() {
        var slug = (0,_data_products__WEBPACK_IMPORTED_MODULE_5__/* .getProductSlugById */ .Ji)(product._id) || product.product_name.toLowerCase();
        window.open("/video-plugin-framework/".concat(slug, "?scroll=more"), "_blank");
    };
    var features = [
        {
            id: 1,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M11 4.5H18.3C19.4201 4.5 19.9802 4.5 20.408 4.71799C20.7843 4.90973 21.0903 5.21569 21.282 5.59202C21.5 6.01984 21.5 6.57989 21.5 7.7V9C21.5 9.93188 21.5 10.3978 21.3478 10.7654C21.1448 11.2554 20.7554 11.6448 20.2654 11.8478C19.8978 12 19.4319 12 18.5 12M13 19.5H5.7C4.5799 19.5 4.01984 19.5 3.59202 19.282C3.21569 19.0903 2.90973 18.7843 2.71799 18.408C2.5 17.9802 2.5 17.4201 2.5 16.3V15C2.5 14.0681 2.5 13.6022 2.65224 13.2346C2.85523 12.7446 3.24458 12.3552 3.73463 12.1522C4.10218 12 4.56812 12 5.5 12M10.3 14.5H13.7C13.98 14.5 14.12 14.5 14.227 14.4455C14.3211 14.3976 14.3976 14.3211 14.4455 14.227C14.5 14.12 14.5 13.98 14.5 13.7V10.3C14.5 10.02 14.5 9.87996 14.4455 9.773C14.3976 9.67892 14.3211 9.60243 14.227 9.5545C14.12 9.5 13.98 9.5 13.7 9.5H10.3C10.02 9.5 9.87996 9.5 9.773 9.5545C9.67892 9.60243 9.60243 9.67892 9.5545 9.773C9.5 9.87996 9.5 10.02 9.5 10.3V13.7C9.5 13.98 9.5 14.12 9.5545 14.227C9.60243 14.3211 9.67892 14.3976 9.773 14.4455C9.87996 14.5 10.02 14.5 10.3 14.5ZM17.8 22H21.2C21.48 22 21.62 22 21.727 21.9455C21.8211 21.8976 21.8976 21.8211 21.9455 21.727C22 21.62 22 21.48 22 21.2V17.8C22 17.52 22 17.38 21.9455 17.273C21.8976 17.1789 21.8211 17.1024 21.727 17.0545C21.62 17 21.48 17 21.2 17H17.8C17.52 17 17.38 17 17.273 17.0545C17.1789 17.1024 17.1024 17.1789 17.0545 17.273C17 17.38 17 17.52 17 17.8V21.2C17 21.48 17 21.62 17.0545 21.727C17.1024 21.8211 17.1789 21.8976 17.273 21.9455C17.38 22 17.52 22 17.8 22ZM2.8 7H6.2C6.48003 7 6.62004 7 6.727 6.9455C6.82108 6.89757 6.89757 6.82108 6.9455 6.727C7 6.62004 7 6.48003 7 6.2V2.8C7 2.51997 7 2.37996 6.9455 2.273C6.89757 2.17892 6.82108 2.10243 6.727 2.0545C6.62004 2 6.48003 2 6.2 2H2.8C2.51997 2 2.37996 2 2.273 2.0545C2.17892 2.10243 2.10243 2.17892 2.0545 2.273C2 2.37996 2 2.51997 2 2.8V6.2C2 6.48003 2 6.62004 2.0545 6.727C2.10243 6.82108 2.17892 6.89757 2.273 6.9455C2.37996 7 2.51997 7 2.8 7Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Visual Graph Editor",
            description: "Design complex processing pipelines with our intuitive node-based editor. Connect, configure, and preview in real-time."
        },
        {
            id: 2,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "22",
                height: "22",
                viewBox: "0 0 22 22",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M8 1V3M14 1V3M8 19V21M14 19V21M19 8H21M19 13H21M1 8H3M1 13H3M7.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19ZM9.6 14H12.4C12.9601 14 13.2401 14 13.454 13.891C13.6422 13.7951 13.7951 13.6422 13.891 13.454C14 13.2401 14 12.9601 14 12.4V9.6C14 9.03995 14 8.75992 13.891 8.54601C13.7951 8.35785 13.6422 8.20487 13.454 8.10899C13.2401 8 12.9601 8 12.4 8H9.6C9.03995 8 8.75992 8 8.54601 8.10899C8.35785 8.20487 8.20487 8.35785 8.10899 8.54601C8 8.75992 8 9.03995 8 9.6V12.4C8 12.9601 8 13.2401 8.10899 13.454C8.20487 13.6422 8.35785 13.7951 8.54601 13.891C8.75992 14 9.03995 14 9.6 14Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Multi-GPU Support",
            description: "Write kernels once for CUDA, Metal, and OpenCL. We handle the optimization and deployment across all platforms."
        },
        {
            id: 3,
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    d: "M12 15L15 12L12 9M8 5L5 8L8 11M5.8 19H14.2C15.8802 19 16.7202 19 17.362 18.673C17.9265 18.3854 18.3854 17.9265 18.673 17.362C19 16.7202 19 15.8802 19 14.2V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z",
                    stroke: "white",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            title: "Native SDK Integration",
            description: "Seamlessly integrates with OpenFX, Adobe SDK, FxPlug, and more. Your plugins feel native in every host."
        }, 
    ];
    var benefits = [
        {
            id: 1,
            title: "Seamless Integration"
        },
        {
            id: 2,
            title: "Modular Kernal System"
        },
        {
            id: 3,
            title: "Back-End Agnostics"
        },
        {
            id: 4,
            title: "Cross-Platform Compatibility"
        },
        {
            id: 5,
            title: "Pre-Built Effect Library"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        id: "product",
        className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().booksSection),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainContainer),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainCard),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().imageContainer),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/product-book-cover.jpg",
                            alt: "VxFX Universal Video Plugin Development Framework - Build Once, Deploy Everywhere",
                            layout: "fill",
                            objectFit: "cover",
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_7__/* .Fade */ .pT, {
                        triggerOnce: true,
                        duration: 800,
                        delay: 400,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().contentContainer),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().header),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().badge),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/vxfx-app-name-book.svg",
                                                alt: "VxFX Video Plugin Development Framework Logo"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                            variant: "text-md",
                                            as: "h2",
                                            color: "grayDark-50",
                                            weight: "bold",
                                            align: "center",
                                            children: "The Universal Video Plugin Development Framework."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                            variant: "text-sm",
                                            as: "p",
                                            color: "grayDark-50",
                                            weight: "normal",
                                            align: "center",
                                            children: "Build Once, Deploy Everywhere."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().boxesContainer),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithBox),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-sm",
                                                    color: "primary",
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithTitle),
                                                    children: "Support"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithGrid),
                                                    children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((product === null || product === void 0 ? void 0 : product.target_applications) || []).map(function(app, index) {
                                                        var iconSrc = "";
                                                        switch(app){
                                                            case "DaVinci Resolve":
                                                                iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
                                                                break;
                                                            case "Adobe Premiere Pro":
                                                                iconSrc = "/logo/Adobe_Premiere_Pro.svg";
                                                                break;
                                                            case "Sony VEGAS Pro":
                                                                iconSrc = "/logo/Vegas_Pro.svg";
                                                                break;
                                                            case "FinalCut":
                                                                iconSrc = "/logo/Final_Cut_Pro.svg";
                                                                break;
                                                            case "Natron":
                                                                iconSrc = "/logo/Natron.svg";
                                                                break;
                                                            case "Nuke":
                                                                iconSrc = "/logo/Nuke.svg";
                                                                break;
                                                            case "Apple Motion":
                                                                iconSrc = "/logo/Apple_Motion.svg";
                                                                break;
                                                            case "NVIDIA CUDA":
                                                                iconSrc = "/logo/NVIDIA_CUDA.svg";
                                                                break;
                                                            case "Apple Metal":
                                                                iconSrc = "/logo/Apple_Metal.svg";
                                                                break;
                                                            case "OpenCL":
                                                                iconSrc = "/logo/OpenCL.svg";
                                                                break;
                                                            case "CPU":
                                                                iconSrc = "/logo/cpu.png";
                                                                break;
                                                            default:
                                                                iconSrc = "";
                                                        }
                                                        return iconSrc ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleItem),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: iconSrc,
                                                                alt: "".concat(app, " - Compatible Video Editing Platform")
                                                            })
                                                        }, index) : null;
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithBox),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-sm",
                                                    color: "primary",
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithTitle),
                                                    children: "Compatible With"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleWithGrid),
                                                    children: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((product === null || product === void 0 ? void 0 : product.supported_gpu_architectures) || []).map(function(app, index) {
                                                        var iconSrc = "";
                                                        switch(app){
                                                            case "DaVinci Resolve":
                                                                iconSrc = "/logo/DaVinci_Resolve_Studio.svg";
                                                                break;
                                                            case "Adobe Premiere Pro":
                                                                iconSrc = "/logo/Adobe_Premiere_Pro.svg";
                                                                break;
                                                            case "Sony VEGAS Pro":
                                                                iconSrc = "/logo/Vegas_Pro.svg";
                                                                break;
                                                            case "FinalCut":
                                                                iconSrc = "/logo/Final_Cut_Pro.svg";
                                                                break;
                                                            case "Natron":
                                                                iconSrc = "/logo/Natron.svg";
                                                                break;
                                                            case "Nuke":
                                                                iconSrc = "/logo/Nuke.svg";
                                                                break;
                                                            case "Apple Motion":
                                                                iconSrc = "/logo/Apple_Motion.svg";
                                                                break;
                                                            case "NVIDIA CUDA":
                                                                iconSrc = "/logo/NVIDIA_CUDA.svg";
                                                                break;
                                                            case "Apple Metal":
                                                                iconSrc = "/logo/Apple_Metal.svg";
                                                                break;
                                                            case "OpenCL":
                                                                iconSrc = "/logo/OpenCL.svg";
                                                                break;
                                                            case "CPU":
                                                                iconSrc = "/logo/cpu.png";
                                                                break;
                                                            default:
                                                                iconSrc = "";
                                                        }
                                                        var title = "";
                                                        switch(app){
                                                            case "NVIDIA CUDA":
                                                                title = "NVIDIA";
                                                                break;
                                                            case "Apple Metal":
                                                                title = "Apple Metal";
                                                                break;
                                                            case "OpenCL":
                                                                title = "Open CL";
                                                                break;
                                                            case "CPU":
                                                                title = "CPU";
                                                                break;
                                                            default:
                                                                title = "";
                                                        }
                                                        return iconSrc ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnItem),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().compatibleItem),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: iconSrc,
                                                                        alt: "".concat(app, " - Compatible Video Editing Platform")
                                                                    })
                                                                }, index),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                    variant: "text-xs",
                                                                    as: "span",
                                                                    weight: "light",
                                                                    color: "grayDark-200",
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: title
                                                                })
                                                            ]
                                                        }, "platform-".concat(index)) : null;
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnBox),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-sm",
                                                    color: "primary",
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnBoxTitle),
                                                    children: "Available On"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnGrid),
                                                    children: ((product === null || product === void 0 ? void 0 : product.supported_platforms) || []).map(function(platform, index) {
                                                        var iconSrc = "";
                                                        switch(platform){
                                                            case "Windows":
                                                                iconSrc = "/logo/Windows.svg";
                                                                break;
                                                            case "MacOS":
                                                                iconSrc = "/logo/macOS.svg";
                                                                break;
                                                            case "Linux":
                                                                iconSrc = "/logo/Linux.svg";
                                                                break;
                                                            default:
                                                                iconSrc = "";
                                                        }
                                                        var title = "";
                                                        switch(platform){
                                                            case "Windows":
                                                                title = "Windows";
                                                                break;
                                                            case "MacOS":
                                                                title = "MacOS";
                                                                break;
                                                            case "Linux":
                                                                title = "Linux";
                                                                break;
                                                            default:
                                                                title = "";
                                                        }
                                                        return iconSrc ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnItem),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().availableOnIcon),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: iconSrc,
                                                                        alt: "".concat(platform, " - Supported Operating System Platform")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                    variant: "text-xs",
                                                                    as: "span",
                                                                    weight: "light",
                                                                    color: "grayDark-200",
                                                                    style: {
                                                                        textAlign: "center"
                                                                    },
                                                                    children: title
                                                                })
                                                            ]
                                                        }, "platform-".concat(index)) : null;
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                    variant: "text-lg",
                                    as: "p",
                                    color: "primary",
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().description),
                                    weight: "normal",
                                    children: "Design, compile, and deploy professional video processing plugins across all major editing platforms with a single visual workflow."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().featuresSection),
                                    children: features.map(function(feature) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().featureCard),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().featureIcon),
                                                    children: feature.icon
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-sm",
                                                    as: "h3",
                                                    color: "primary",
                                                    weight: "bold",
                                                    children: feature.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-xs",
                                                    as: "p",
                                                    color: "secondary",
                                                    weight: "normal",
                                                    style: {
                                                        color: "#CBD5E1"
                                                    },
                                                    children: feature.description
                                                })
                                            ]
                                        }, feature.id);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefitsSection),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefitsList),
                                        children: benefits.map(function(benefit) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().benefitItem),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().checkIcon),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                            width: "16",
                                                            height: "16",
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8Z",
                                                                    fill: "#6A2DC7"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M5 8L7 10L11 6",
                                                                    stroke: "white",
                                                                    strokeWidth: "1.5",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                        variant: "text-xs",
                                                        color: "primary",
                                                        weight: "normal",
                                                        children: benefit.title
                                                    })
                                                ]
                                            }, benefit.id);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_books_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ctaSection),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            variant: "secondary",
                                            fullWidth: true,
                                            onClick: handleLearnMore,
                                            children: "Learn More"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
                                            variant: "warning",
                                            fullWidth: true,
                                            onClick: handleFreeTrial,
                                            children: "Buy Now"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Books);


/***/ }),

/***/ 7069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ji": function() { return /* binding */ getProductSlugById; },
/* harmony export */   "WO": function() { return /* binding */ getProductIdBySlug; },
/* harmony export */   "Zc": function() { return /* binding */ productsData; }
/* harmony export */ });
var productsData = [
    {
        id: "6746ae8608b3efcbfedd1063",
        title: "Video Plugins",
        products: [
            {
                id: "6747fa1353ed45d740942f0d",
                product_name: "VxFX",
                icon: "/products/vxfx.png",
                slug: "vxfx"
            }, 
        ]
    }, 
];
/**
 * Finds product ID by slug
 * @param slug - The product slug
 * @returns Product ID or null if not found
 */ function getProductIdBySlug(slug) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.slug === slug;
            });
            if (product) {
                return product.id;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
/**
 * Finds product slug by ID
 * @param id - The product ID
 * @returns Product slug or null if not found
 */ function getProductSlugById(id) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = productsData[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var category = _step.value;
            var product = category.products.find(function(p) {
                return p.id === id;
            });
            if (product) {
                return product.slug;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}


/***/ }),

/***/ 63532:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"booksSection":"books_booksSection__dJjAQ","mainContainer":"books_mainContainer__iKAF2","mainCard":"books_mainCard__2t7w0","imageContainer":"books_imageContainer__1ROzO","contentContainer":"books_contentContainer__97cPW","header":"books_header__nFBnp","badge":"books_badge__e0tv2","boxesContainer":"books_boxesContainer__2QQFd","compatibleWithBox":"books_compatibleWithBox__62tsx","availableOnBox":"books_availableOnBox__NqbB3","compatibleWithTitle":"books_compatibleWithTitle__xpWfJ","availableOnBoxTitle":"books_availableOnBoxTitle__QRvx4","compatibleWithGrid":"books_compatibleWithGrid__KHkYe","compatibleItem":"books_compatibleItem__hW6_N","availableOnGrid":"books_availableOnGrid__RzvD_","availableOnItem":"books_availableOnItem__S3i47","availableOnIcon":"books_availableOnIcon__suj5o","description":"books_description__ygtm1","featuresSection":"books_featuresSection__X1nCG","featureCard":"books_featureCard__DNg8O","featureIcon":"books_featureIcon__61bYf","benefitsSection":"books_benefitsSection__MuSc_","benefitsList":"books_benefitsList__O_Kp4","benefitItem":"books_benefitItem__PFWe4","checkIcon":"books_checkIcon__2ZCTf","ctaSection":"books_ctaSection__XC8Rg"};

/***/ })

}]);